import React, { useState, useEffect, useRef } from "react";
import { TextField, Grid, Paper, Typography, Button, Backdrop, CircularProgress, Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InputMask from "react-input-mask";
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';
import { MobileNumberValidation } from "../utils/MobileNumberCheck";

function CustomerRepresenterForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [customerRepresenterCode, setCustomerRepresenterCode] = useState('');
    const [friendMobileNumber, setFriendMobileNumber] = useState('');

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize: 'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const footerButtonStyle = {
        display: 'inline-block',
        padding: '0px 20px',
        width: '50%'
    };

    const footerButtonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed', left: '0',
        bottom: '0', width: '100%',
        zIndex: '1'
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    useEffect(() => {
        setOpen(true);
        axios.get('/api/v1/Profile/GetCustomerRepresenterCode', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then((res) => {
            setCustomerRepresenterCode(res.data);
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        let mobileObject = MobileNumberValidation(friendMobileNumber);
        if (mobileObject.isValid) {
            setOpen(true);
            axios.post('/api/v1/Profile/SendCustomerRepresenterCodeToFriend', null,
                {
                    params: {
                        CustomerId: getAuthenticationToken().userID,
                        FriendMobileNumber: friendMobileNumber
                    }
                }
            ).then(response => {
                setMessageNotify({
                    severity: "success",
                    message: "کد معرف با موفقیت ارسال شد",
                    open: true
                });
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ارسال اطلاعات به سرور",
                    open: true
                });
            }).finally(() => {
                setOpen(false);
            })
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "شماره تلفن همراه به صورت صحیح وارد نشده است",
                open: true
            });

        }
    }

    return (<>
        <div style={{ margin: '40px 0px 15px 0px', textAlign: 'center', fontSize: 'large' }}>
            معرفی <span style={{ color: '#ffff00' }}>باشگاه مشتریان <span style={{ fontSize: 'large', fontWeight: 'bold' }}>NEC</span></span> به دوستان
        </div>
        <div style={{ textAlign: 'center', padding: '0px 10px' }}>
            <span style={{ fontSize: 'small' }}>شماره تلفن همراه دوستان را جهت دعوت </span>
        </div>
        <div style={{ textAlign: 'center', padding: '0px 10px' }}>
            <span style={{ fontSize: 'small' }}>بــه بــاشــگــاه مــشــتــریـان NEC وارد کــنـیـد</span>
        </div>
        <div style={{ textAlign: 'center', padding: '0px 10px' }}>
            <span style={{ fontSize: 'small' }}>و بـا ثـبـت نـام ایـشـان امـتیـاز کـسـب کـنـیـد
            </span>
        </div>
        <form onSubmit={handleSubmit}>

            <div style={{ textAlign: 'center', padding: '0px 10px', margin: '20px 30px' }}>
                <div style={{ fontSize: '1.3rem', fontWeight: 'bold',textAlign:'right',margin:'0 1.3rem 0 0' }}> کد معرف شما: </div>
                <div style={{ fontSize: '1.2rem', padding: '8px 5px', borderRadius: '1.3rem', margin: '10px', background: 'radial-gradient(#0072bc, #034ea2)' }}>{customerRepresenterCode}</div>
            </div>
            <Grid>
                <div style={paperStyle}>
                    <InputMask
                        mask="99999999999"
                        maskChar=" "
                        value={friendMobileNumber}
                        onChange={e => setFriendMobileNumber(e.target.value)}
                    >
                        {() => <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="postalCode"
                            name="postalCode"
                            label="شماره همراه دوست"
                            fullWidth
                            variant="standard" />}
                    </InputMask>
                </div>
            </Grid>
            <div style={footerButtonContainerStyle}>
                    <div style={footerButtonStyle}>
                        <Button
                            id="submit"
                            type='submit'
                            name="submit"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>ثبت</Button>
                    </div>
                    <div style={footerButtonStyle}>
                        <Button
                            onClick={() => { props.history.push('/') }}
                            id="cancel"
                            name="cancel"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>انصراف</Button>
                    </div>
                </div>
        </form>
        <MaterialNotifyComponent open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </>
    );
}

export default withRouter(CustomerRepresenterForm);